import '../Tutorial.css';
import React from 'react';
import TutorialGirl from "../TutorialGirl";
import Typewriter from "typewriter-effect";

function T90MenuResearch() {

    /*
  useEffect(() => {
    UserService.sendEvent('MenuResearch90');
  }, []);
 */

  const text = 'Close the window, and I\'ll explain everything to you.';

    return (
        <div>

            <div className={'T90Left'}></div>
            <div className={'T90Bottom'}></div>

            <TutorialGirl undressingProcess={3}/>
            <div className='tutorialContainer tutorialBottomContainer'>
                <div className='tutorialBottomTextField'><Typewriter
                    options={{
                        delay: 30
                    }}
                    onInit={(typewriter) => {
                        typewriter.typeString(text).start();
                    }}
                /></div>
            </div>
        </div>

    );
}

export default T90MenuResearch;
